module.exports = __webpack_public_path__ + "img/dynamic-21.2c53929e.png";